import { useId } from "react";
import ReactSelect, { OnChangeValue, StylesConfig } from "react-select";
import { useGroupSelect } from "./hooks";

type OptionType = { value: string; label: string };

/**
 * グループを選択するためのセレクトボックスコンポーネント
 * 複数選択のみ対応
 *
 * @param selectedIds - 選択されているグループのID
 * @param onSelect - グループが選択された時のコールバック関数
 * @param tenantId - ServiceProviderアカウントの場合は必須。組織のID
 * @param width - コンポーネントの横幅
 * @param maxHeight - コンポーネントの最大高さ
 */
export const MultiGroupSelect = ({
  selectedIds,
  onSelect,
  tenantId,
  width = "80%",
  maxHeight = "72px",
}: {
  selectedIds: string[];
  onSelect: (ids: string[]) => void;
  tenantId?: string;
  width?: string;
  maxHeight?: string;
}) => {
  const { isLoading, searchGroups, candidates, page, setPage, totalPage } =
    useGroupSelect(selectedIds, tenantId);

  const handleOnChange = (v: OnChangeValue<OptionType, true>) => {
    onSelect(v.map((option) => option.value));
  };

  const customStyles: StylesConfig<OptionType, true> = {
    valueContainer: (provided) => {
      return {
        ...provided,
        maxHeight,
        overflowY: "auto",
      };
    },
  };

  return (
    <div style={{ fontSize: "14px", width, minWidth: "298px" }}>
      <ReactSelect
        styles={customStyles}
        isClearable
        isMulti
        placeholder={
          candidates.length === 0 ? "グループ検索中..." : "グループで絞り込む"
        }
        value={candidates.filter((c) => selectedIds.includes(c.value))}
        onInputChange={(text) => {
          searchGroups(text);
        }}
        onChange={handleOnChange}
        inputId={`group-select-${useId()}`}
        options={candidates}
        isLoading={isLoading}
        loadingMessage={() => "グループ検索中..."}
        noOptionsMessage={() => "グループがありません"}
        onMenuScrollToBottom={() => {
          if (page < totalPage) {
            setPage((prev) => prev + 1);
          }
        }}
      />
    </div>
  );
};
